<script>
import api from "@/helpers/api-rest/api.js";

export default {
  name: "ProjectSelectModal",
  data() {
    return {
      projects: [],
      selectedProject: null,
      loading: false,
      filter: "",
    };
  },
  mounted() {
    this.loadProjects();
  },
  methods: {
    async loadProjects() {
      this.loading = true;
      try {
        const apiEndpoint = `/api/v1/projects?status=1`;
        const response = await api.get({ url: apiEndpoint });
        this.projects = response?.data?.data || [];
      } catch (error) {
        console.error("Error loading projects:", error);
        this.projects = [];
      } finally {
        this.loading = false;
      }
    },
    selectProject(project) {
      this.selectedProject = project;
    },
    confirmSelection() {
      if (this.selectedProject) {
        this.$emit("project-selected", this.selectedProject);
        this.$bvModal.hide("ModalProjectSelect");
        this.selectedProject = null;
      }
    },
    cancel() {
      this.$bvModal.hide("ModalProjectSelect");
      this.selectedProject = null;
    },
    getFilteredProjects() {
      if (!this.filter) return this.projects;
      const searchTerm = this.filter.toLowerCase();
      return this.projects.filter(
        (project) =>
          project.name?.toLowerCase().includes(searchTerm) ||
          project.description?.toLowerCase().includes(searchTerm)
      );
    },
  },
};
</script>

<template>
  <b-modal
    id="ModalProjectSelect"
    size="lg"
    title="Seleccionar Convocatoria"
    no-close-on-backdrop
    @hidden="cancel"
  >
    <template #default>
      <div v-if="loading" class="text-center p-4">
        <b-spinner variant="primary"></b-spinner>
        <p class="mt-2">Cargando convocatorias...</p>
      </div>
      <div v-else>
        <!-- Search Input -->
        <div class="mb-3">
          <b-form-input
            v-model="filter"
            type="search"
            placeholder="Buscar convocatoria..."
            class="form-control"
          ></b-form-input>
        </div>

        <!-- Projects List -->
        <div
          v-if="getFilteredProjects().length === 0"
          class="text-center p-4 text-muted"
        >
          <i class="ri-file-list-line font-size-24 mb-2"></i>
          <p>No se encontraron convocatorias activas</p>
        </div>

        <div
          v-else
          class="project-list"
          style="max-height: 400px; overflow-y: auto"
        >
          <div
            v-for="project in getFilteredProjects()"
            :key="project.id"
            class="project-item mb-2 p-3 border rounded cursor-pointer"
            :class="{
              'border-primary bg-light': selectedProject?.id === project.id,
              'border-secondary': selectedProject?.id !== project.id,
            }"
            @click="selectProject(project)"
            style="transition: all 0.2s ease"
          >
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <h6 class="mb-1 font-weight-bold">{{ project.name }}</h6>
                  <p
                    class="mb-0 text-muted small"
                    style="
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    "
                  >
                  {{ project.description || "Sin descripción" }}
                </p>
                <div class="mt-2">
                  <b-badge
                    pill
                    :variant="project.project_type_id === 1 ? 'info' : 'light'"
                    class="mr-2"
                  >
                    {{ project.project_type?.name }}
                  </b-badge>
                </div>
              </div>
              <div class="ml-3">
                <i
                  v-if="selectedProject?.id === project.id"
                  class="ri-checkbox-circle-fill text-primary font-size-24"
                ></i>
                <i
                  v-else
                  class="ri-checkbox-blank-circle-line text-muted font-size-24"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <b-button variant="secondary" @click="cancel">Cancelar</b-button>
      <b-button
        variant="primary"
        @click="confirmSelection"
        :disabled="!selectedProject"
      >
        Seleccionar
      </b-button>
    </template>
  </b-modal>
</template>

<style scoped>
.project-item {
  cursor: pointer;
}

.project-item:hover {
  background-color: #f8f9fa !important;
  transform: translateX(4px);
}

.cursor-pointer {
  cursor: pointer;
}
</style>
